import { useState } from "react";

export default function AdminLogin() {
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");

  const handleLoginAdmin = async () => {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/auth/adminLogin`,
      {
        method: "POST",
        //headers brauchen wir sodass das Backend weiß, dass wir JSON-Daten senden
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ name, password }),
      },
    );
    const data = await response.json();
    if (data.success) {
      localStorage.setItem("adminToken", data.token);
      window.location.href = "/admin/dashboard";
    }
    console.log(data);
  };

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Syne:wght@700;800&family=DM+Sans:wght@300;400;500&display=swap');
        .admin-login-wrap {
          min-height: 100vh;
          background: #0a0a0f;
          display: flex;
          align-items: center;
          justify-content: center;
          font-family: 'DM Sans', sans-serif;
        }
        .admin-login-box {
          background: #14141e;
          border: 1px solid rgba(255,255,255,0.07);
          border-radius: 20px;
          padding: 48px;
          width: 100%;
          max-width: 420px;
        }
        .admin-badge {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          background: rgba(200,241,53,0.1);
          border: 1px solid rgba(200,241,53,0.2);
          color: #c8f135;
          padding: 5px 14px;
          border-radius: 100px;
          font-size: 0.7rem;
          font-weight: 700;
          letter-spacing: 0.08em;
          text-transform: uppercase;
          margin-bottom: 24px;
        }
        .admin-login-box h1 {
          font-family: 'Syne', sans-serif;
          font-size: 1.9rem;
          font-weight: 800;
          color: #f0f0f0;
          letter-spacing: -0.03em;
          margin-bottom: 8px;
        }
        .admin-login-box p {
          color: #6b6b7a;
          font-size: 0.875rem;
          margin-bottom: 36px;
        }
        .admin-form-group { margin-bottom: 20px; }
        .admin-form-group label {
          display: block;
          font-size: 0.75rem;
          font-weight: 600;
          color: #6b6b7a;
          letter-spacing: 0.05em;
          text-transform: uppercase;
          margin-bottom: 8px;
        }
        .admin-form-group input {
          width: 100%;
          background: rgba(255,255,255,0.04);
          border: 1px solid rgba(255,255,255,0.07);
          border-radius: 10px;
          padding: 12px 16px;
          color: #f0f0f0;
          font-family: 'DM Sans', sans-serif;
          font-size: 0.9rem;
          outline: none;
          transition: border-color 0.2s;
        }
        .admin-form-group input:focus {
          border-color: rgba(200,241,53,0.4);
        }
        .admin-form-group input::placeholder { color: #3a3a4a; }
        .admin-btn {
          width: 100%;
          background: #c8f135;
          color: #0a0a0f;
          border: none;
          border-radius: 10px;
          padding: 13px;
          font-family: 'DM Sans', sans-serif;
          font-size: 0.95rem;
          font-weight: 700;
          cursor: pointer;
          margin-top: 8px;
          transition: opacity 0.2s, transform 0.2s;
        }
        .admin-btn:hover { opacity: 0.88; transform: translateY(-1px); }
      `}</style>

      <div className="admin-login-wrap">
        <div className="admin-login-box">
          <div className="admin-badge">Admin Panel</div>
          <h1>Willkommen zurück</h1>
          <p>Melde dich in deinem Admin-Account an</p>

          <div className="admin-form-group">
            <label>Name</label>
            <input
              type="text"
              placeholder="Mustermann"
              value={name}
              // onChange wird benötigt da der Browser bei jeder Eingabe ein Event-Objekt mitschickt.
              // e.target.value enthält den aktuellen Wert des Input-Feldes.
              // Die Arrow-Funktion "entpackt" das Event und gibt nur den Wert an setName weiter.
              onChange={(e) => setName(e.target.value)}
            />
          </div>

          <div className="admin-form-group">
            <label>Passwort</label>
            <input
              type="password"
              placeholder="••••••••"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>

          <button className="admin-btn" onClick={handleLoginAdmin}>
            Einloggen
          </button>
        </div>
      </div>
    </>
  );
}
